<template>
	<BaseTooltip :enabled="!disabledTooltip && !disabled" :text="label" placement="top" class="w-20 h-20">
		<button
			class="p-2 w-20 h-20 flex items-center justify-center player-control-button"
			:disabled="disabled"
			@click="$emit('click')"
		>
			<slot />
			<span v-if="label" class="sr-only">{{ label }}</span>
		</button>
	</BaseTooltip>
</template>

<script>
export default {
	name: 'PlayerControlButton',
	props: {
		disabled: Boolean,
		label: {type: String, default: ''},
		disabledTooltip: Boolean,
	},
	emits: ['click'],
}
</script>

<style>
.player-control-button[disabled] {
	opacity: 0.5;
}

.player-control-button:not([disabled]) {
	color: var(--gray-400);
}
.player-control-button:hover:not([disabled]) {
	color: var(--gray-200);
}
</style>
